var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 2.50008C1.6665 2.03984 2.0396 1.66675 2.49984 1.66675H9.99638C10.4566 1.66675 10.8297 2.03984 10.8297 2.50008C10.8297 2.96032 10.4566 3.33341 9.99638 3.33341H3.33317V16.6667H9.99984C10.4601 16.6667 10.8332 17.0398 10.8332 17.5001C10.8332 17.9603 10.4601 18.3334 9.99984 18.3334H2.49984C2.0396 18.3334 1.6665 17.9603 1.6665 17.5001V2.50008Z",
    fill: "#AA8768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1606 5.66083C13.486 5.33539 14.0137 5.33539 14.3391 5.66083L18.0891 9.41083C18.4145 9.73626 18.4145 10.2639 18.0891 10.5893L14.3391 14.3393C14.0137 14.6648 13.486 14.6648 13.1606 14.3393C12.8351 14.0139 12.8351 13.4863 13.1606 13.1608L16.3213 10.0001L13.1606 6.83934C12.8351 6.5139 12.8351 5.98626 13.1606 5.66083Z",
    fill: "#AA8768"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.8335 9.99642C5.8335 9.53618 6.20659 9.16309 6.66683 9.16309H17.5002C17.9604 9.16309 18.3335 9.53618 18.3335 9.99642C18.3335 10.4567 17.9604 10.8298 17.5002 10.8298H6.66683C6.20659 10.8298 5.8335 10.4567 5.8335 9.99642Z",
    fill: "#AA8768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.ee4d89eb8c1523c425c6112a0dfaf77d.svg";
export { ForwardRef as ReactComponent };